var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.displayNextPage || _vm.displayPreviousPage
      ? _c(
          "ul",
          {
            key: _vm.resetPagination,
            staticClass:
              "d-flex flex-row-reverse p-0 align-items-center justify-content-center list-style-none",
          },
          [
            _vm.displayNextPage || _vm.displayPreviousPage
              ? _c("li", [
                  _c("p", { staticClass: "resultsTextPagination ml-3" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("common.results_desc") +
                          " " +
                          _vm.firstIndex +
                          " " +
                          _vm.$t("common.to") +
                          " " +
                          _vm.lastResultIndex
                      )
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.displayNextPage
              ? _c(
                  "li",
                  {
                    staticClass: "p-2 pagination-button cursor",
                    on: {
                      click: function ($event) {
                        return _vm.pagination(_vm.currentPage + 1)
                      },
                    },
                  },
                  [_c("i", { staticClass: "fa-solid fa-chevron-right" })]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.displayPreviousPage
              ? _c(
                  "li",
                  {
                    staticClass: "p-2 pagination-button cursor",
                    on: {
                      click: function ($event) {
                        return _vm.pagination(_vm.currentPage - 1)
                      },
                    },
                  },
                  [_c("i", { staticClass: "fa-solid fa-chevron-left" })]
                )
              : _vm._e(),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }